module.exports = __webpack_public_path__ + "static/chooseAdventure-4ccd47394d905682a16d18eb989931cc.jpg";